import {Component, OnDestroy, OnInit} from '@angular/core';
import {Company, EnterpIntroductionServiceService} from "../../services/enterp-introduction-service.service";
import {HttpCommonService} from "../../services/http-common.service";
import {NzMessageService, NzModalService, NzModalSubject} from "ng-zorro-antd";
import {AttentionGroupService} from "../../services/attention-group.service";
import {GlobalService} from "../../services/global.service";
import {ActivatedRoute, Params, Router} from "@angular/router";
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/mergeMap';
import {EnterpPortraitService} from "../../services/enterp-portrait.service";
import {CheckSuperviseGuard} from "../../guard/checkSuperviseGuard";
import {EnterCertifitionListService} from "../../services/enter-certification-list.service";
import {LoginModalComponent} from "../login-modal/login-modal.component";
import {User} from "../../models/user";
import {SuperviseService} from "../../services/supervise.service";
import {Title} from "@angular/platform-browser";


@Component({
  selector: 'app-enterp-introduction',
  templateUrl: './enterp-introduction.component.html',
  styleUrls: ['./enterp-introduction.component.css']
})
export class EnterpIntroductionComponent implements OnInit, OnDestroy {
  isCertific = '1';//企业是否认证
  claimCount: string;//企业认领数量
  isClaim: boolean;//是否已认领企业
  companyInfo: Company;//基础信息
  isSelf: boolean;//是否是查看自己企业
  isSupervise: any;//是否已监管
  isVip = false;// 是否为大客户
  isVisible = false;//企业用户创建名片弹窗
  isVisible2 = false;//个人用户创建名片弹窗
  isVisible3 = false;//企业用户入驻企业弹窗
  user: User;
  order: any;

  constructor(private companyService: EnterpIntroductionServiceService,
              private httpService: HttpCommonService,
              private showConfirm: NzModalService,
              private attentionGroupService: AttentionGroupService,
              private globalService: GlobalService,
              private router: Router,
              private superviseServ: SuperviseService,
              private routerInfo: ActivatedRoute,
              private ecls: EnterCertifitionListService,
              private showAlert: NzModalService,
              private showMsg: NzMessageService,
              private eps: EnterpPortraitService,
              private checkSuperviseGuard: CheckSuperviseGuard,
              private titleService: Title,
              public supSev: SuperviseService,
              private subject: NzModalSubject) {
    this.titleService.setTitle('企业档案-新华信用');
    this.user = new User();
    this.user.id = this.globalService.getUserInfo('_userId');
    this.companyService.isFromQi = true;// 使用企查查接口
  }

  attentionInfo: any;//
  basicUrl: String = "/enterprise/detail";
  modal: any;
  hasCard: boolean;//是否有企业名片
  userId: string;
  companyId: any; // 企业id
  isLogin: any;
  userType: any;
  aType: any; // 跳转类别，1表示从我的主页跳转
  hadCard: boolean;
  logCompanyId: string;
  companyName: string;
  isUnderEntry = '0';
  newEnter: any = {};
  bankAccountNo: any = null; //企业银行账号
  bankAccountName: any = null; //企业银行帐户名
  bankDeposit: any = null;//开户行
  newbankDeposit: any = null;
  cityId: any = null; //所属市id
  cityName: any = null; //所属市
  provinceId: any = null; //所属省id
  provinceName: any = null;//所属省
  orderNo: any = null;
  xhCode: any = null;
  isCompanyLoaded = false;//企业信息是否加载完成


  //二维码图片
  imageQRCode: any = "../../../assets/images/qrcode-base.jpg";

  ngOnInit() {
    this.ready1();
    this.searchXhCode();
    // console.log(222222222);

    // console.log(this.companyResult);
    this.routerInfo.queryParams.subscribe((params: Params) => {
        this.aType = params['aType'];
        // 从我的主页跳转来
        if (this.aType == 1) {
          this.companyId = this.globalService.getUserInfo("_companyId");
        } else {
          this.companyId = this.routerInfo.snapshot.queryParams['companyId'];
        }
        this.userType = this.globalService.getUserInfo("_userType");
        this.logCompanyId = this.globalService.getUserInfo("_companyId");
        this.isSelf = this.companyId == this.logCompanyId;
        // console.log(this.globalService.getUserInfo("_pType"));
        this.claimCount = '0';//默认为0
        this.isClaim = true;
        this.attentionInfo = {"isAttention": "-1"};
        this.hadCard = false;
        if (this.companyService.isFromQi) {
          this.companyService.getCompanyName(this.companyId).subscribe(data => {
            if (data.data.returnData != null) {
              this.companyName = data.data.returnData[0].name;
              this.getCompany();// 企查查接口需先获取companyName
            }
          });
        } else {
          this.getCompany();
        }

        //企业是否入驻
        this.httpService.get("/user/center/xhsRest/certifi/isHasCertific", {companyId: this.companyId})
          .subscribe(result => {
            this.isCertific = result.data;
          });
        if (this.userType == "person") {
          //企业是否在入驻流程中
          // console.log(this.companyId);
          this.ecls.isUnderEntry(this.companyId)
            .subscribe(result => {
              // console.log(result);
              if (result.stateCode == '1') {
                this.isUnderEntry = result.data;
              }
            });
        }
        //企业认领数量
        this.httpService.get(this.basicUrl + "/xhsRest/claim/getClaimCount", {companyId: this.companyId})
          .subscribe(result => {
            this.claimCount = result.data;
          });

        // 是否已认领企业
        this.httpService.get(this.basicUrl + "/xhsRest/claim/isClaim", {companyId: this.companyId})
          .subscribe(result => {
            this.isClaim = result.data;//是否认领
          });

        //关注信息获取
        this.httpService.get(this.basicUrl + "/xhsRest/atten/getAttentionInfo", {companyId: this.companyId})
          .subscribe(result => {
            this.attentionInfo.isAttention = result.data;
          });
        //是否存在企业名片
        this.httpService.get(this.basicUrl + "/card/getEnterpriseCard",
          {type: "1", companyId: this.companyId, queryType: "1"})
          .subscribe(result => {
            if (result.stateCode == "40301") {
              this.hasCard = true;
            } else {
              this.hasCard = false;
            }
          });
        this.attentionGroupService.subject$.subscribe((value: any) => {
          //console.log(value);
        });
        // this.ready();
        this.userId = this.globalService.getUserInfo('_userId');
        this.logCompanyId = this.globalService.getUserInfo('_companyId');

      }
    );
    //查看企业是否为机构用户
    this.httpService.get("/user/center/xhsRest/hasPermission", {permissionId: "company:checkSupervise"})
      .subscribe(data => {
        // console.log(data);
        if (data.data > 0) {
          this.isVip = true;
        } else {
          this.isVip = false;
        }
      });


    //查看企业是否已监测
    this.httpService.get("/enterprise/detail/xhsRest/supervise/hasSupervise", {companyId: this.companyId})
      .subscribe(data => {
        this.isSupervise = data.data;
        // console.log(data);
      });
    this.calcScore();// 计算企业信用分
    //添加查询历史
    this.httpService.get("/enterprise/detail/xhsRest/baseMsg/addHistorySearch", {"companyId": this.companyId})
      .subscribe(result => {
      });
    this.queryEnter(this.companyId);

    //获取订单信息
    this.httpService.get("/user/center/xhsRest/entry/selectOrderNo", {companyId: this.companyId}).subscribe(data => {
      console.log(data.data);
      this.order = data.data;
    });
  }


  searchXhCode() {
    this.routerInfo.queryParams.subscribe((params: Params) => {
        this.aType = params['aType'];
        // 从我的主页跳转来
        if (this.aType == 1) {
          this.companyId = this.globalService.getUserInfo("_companyId");
        } else {
          this.companyId = this.routerInfo.snapshot.queryParams['companyId'];
        }
        // console.log(3333333);
        this.httpService.get('/user/center/myMessage/getXhCodeByCompanyId', {companyId: this.companyId})
          .subscribe(data => {
            if (data.data != null && data.data != '') {
              this.xhCode = data.data.xhCode;
            }
            // console.log(data);
            // console.log(1111111111111111111111111);
          });
      }
    );
  }

  //取消监测
  concelSupervise() {
    if(!this.isCompanyLoaded){
      return;
    }
    let thiss = this;
    this.showConfirm.confirm({
      content: "确认取消监测？", onOk() {
        thiss.httpService.get('/enterprise/detail/xhsRest/supervise/unSuperviseCompany', {companyId: thiss.companyId})
          .subscribe(data => {
            thiss.isSupervise = '-1';
            thiss.showMsg.success("已移出监测列表");
          });
      }
    });
  }

  //增加监管
  /*gotoSupervise() {
    if(!this.isCompanyLoaded){
      return;
    }
    if (this.userType != "enterprise" && this.userType != "person") {
      this.openLogin();
    } else if (this.userType == "person") {
      this.showAlert.open({
        content: PermissionComparisonComponent,
        componentParams: {companyId: this.companyId},
        width: 650,
        onCancel() {
        },
        onOk() {
        },
        footer: false
      });
    } else {
      let supervise = () => {
        this.httpService.get('/enterprise/detail/xhsRest/supervise/superviseCompany', {companyId: this.companyId})
          .subscribe(data => {
            if (data.stateCode == '1') {
              let thiss = this;
              if ('1' == data.data) {
                this.supSev.getSupervisePushWay().subscribe(result => {
                  console.log(result);
                  if(result.data == null){
                    // 可以添加
                    this.isSupervise = '0';
                    this.showAlert.confirm({
                      title: '',
                      okText: '前往设置',
                      cancelText: '取消',
                      content: '已加入监测列表，您可进入个人中心-监测中心-监测列表，页面查看监测企业信息，设置风险预警方式',
                      onOk() {
                        thiss.router.navigate(['/MemberCenterParent/monitorParent/riskPush']);
                      },
                      onCancel() {
                      }
                    });
                  }else{
                    // 可以添加
                    this.isSupervise = '0';
                  }
                });

              } else {

                // 添加监测数量已经满了；跳转权益对比页面。
                thiss.showAlert.open({
                  content: PermissionComparisonComponent,
                  width: 650,
                  onCancel() {
                  },
                  onOk() {
                  },
                  footer: false
                });
              }
            } else {
              this.showMsg.error('监测企业失败');
            }
          });
      };
      let openComparison = () => {
        this.showAlert.open({
          content: PermissionComparisonComponent,
          width: 650,
          onCancel() {
          },
          onOk() {
          },
          footer: false
        });
      };

      //监测上限 普通企业 10，机构用户 2000
      this.superviseServ.getSuperviseAmount().subscribe(result => {
        if (result.stateCode == '1') {
          let amount = parseInt(result.data);
          if (amount >= 2000) {
            openComparison();
          } else if (this.isVip || amount < 10) {
            supervise();
          } else {
            openComparison();
          }
        }
      });

    }
  }*/

//信用报告下载
  creditReportDownload() {

    let thiss = this;
    if (this.userType != "enterprise" && this.userType != "person") {
      //thiss.showAlert.error({content: '需要登录后才可以下载报告', width: '300px', okText: '确认'});
      thiss.openLogin();
    } else if (this.userType == "enterprise") {
      thiss.router.navigate(["creditReportDownload"],
        {queryParams: {companyId: thiss.companyId}});
    }
    else {
      this.httpService.get("/user/center/xhsRest/isRealAuthent")
        .subscribe(result => {
          if (result.data == "0") {//未认证
            this.showConfirm.confirm({
              title: '',
              content: '未实名认证，是否前往实名认证',
              onOk() {
                thiss.router.navigate(['MemberCenterParent/PersonInfoParent/centerRealName'],
                  {queryParams: {companyId: thiss.companyId, type: '1'}});
              },
              onCancel() {
              }
            });
          } else if (result.data == "1") {
            thiss.showConfirm.info({
              content: '您尚未通过个人实名认证审核，请耐心等待',
              okText: '确定'
            });
          } else {//已认证
            thiss.router.navigate(["creditReportDownload"],
              {queryParams: {companyId: thiss.companyId}});
          }
        });

    }
  }

  // 基本信息
  getCompany() {
    let isFromDetail = "1"; // 表示是在企业详情发出的请求接口
    this.companyService.getCompany(this.companyId, this.companyName, isFromDetail).subscribe(data => {
      //console.log(data)
      if (data.stateCode == '60111') {
        //this.companyResult['company'] = data.data.returnData[0];

        if (!this.companyService.isFromQi) {
          this.companyName = data.data.returnData[0].name;
          this.companyInfo = new Company(data.data.returnData[0], this.companyService.isFromQi);
        } else {
          data.data.Result.imgUrl = data.data.imgUrl;
          this.companyInfo = new Company(data.data.Result, this.companyService.isFromQi);
        }
        this.isCompanyLoaded = true;
        //获取二维码
        this.getQRCode();
      } else if (this.companyService.isFromQi) {// 企查查没有数据
        this.companyService.isFromQi = false;// 使用自己平台接口
        this.getCompany();
      } else {
        this.companyInfo = null;
        //企业信息为空，二维码展示默认图
        $("#imageQRCode").attr("src", this.imageQRCode);
        $("#imageQRCode").show();
      }

    }, (err) => {
    });
  }

  //企业关注
  /*attention() {
    let thiss = this;

    if (this.userType != "enterprise" && this.userType != "person") {
      // thiss.showAlert.error({content: '需要登录后才可以关注企业',width: '300px',okText: '确认'});
      this.openLogin();
    } else {
      thiss.showConfirm.open({
        content: AttentionGroupComponent,
        componentParams: {
          companyId: this.companyId
        },
        width: 360,
        onCancel() {
        },
        onOk() {
          thiss.attentionInfo.isAttention = '0';
        },
        footer: false
      });
    }
  }*/

//取消关注
  concelAttention() {
    let thiss = this;
    this.showConfirm.confirm({
      title: '',
      content: '是否取消关注？',
      onOk() {
        thiss.httpService.post(thiss.basicUrl + "/xhsRest/atten/updateAttentionInfo",
          {companyId: thiss.companyId, isAtten: "1"})
          .subscribe(result => {

            if (result.stateCode == "70001") {
              thiss.showMsg.success("取消关注成功");
            } else if (result.stateCode == "70002") {
              thiss.showAlert.error({content: '取消关注失败', width: '300px', okText: '确认'});
            }
          });
        thiss.attentionInfo.isAttention = '-1';
      },
      onCancel() {
      }
    });


  }

  //带参跳转企业注册
  toRegisterEnterp() {
    if (this.companyInfo && this.companyInfo.creditCode) {//判断企业是否有信息且有社会信用码
      this.httpService.get("/auth/jwt/logout").subscribe(data => {
        this.globalService.checkLoginState();
        this.globalService.deleteLocalStorage();
        this.globalService.isLoginedUser = false;
        this.router.navigate(['registerEnterp'], {queryParams: {companyId: this.companyId, type: '1'}});
      });
    } else {
      this.showAlert.error({content: '该企业未进行三证合一,尚无统一社会信用码,请到工商部门换发新版营业执照', width: '350px', okText: '确认'});
    }
  }

  //弹出登录页面
  openLogin() {
    let thiss = this;
    this.showConfirm.open({
      zIndex: 5,
      content: LoginModalComponent,
      width: 360,
      footer: false,
      onCancel() {
      },
      onOk() {
      },
    });
  }

  //弹出企业登录页面
  openLoginEnterp() {
    let thiss = this;
    this.showConfirm.open({
      zIndex: 5,
      content: LoginModalComponent,
      width: 360,
      componentParams: {selectIndex: '1', isPersonLogin: '2'},
      footer: false,
      onCancel() {
      },
      onOk() {
      },
    });
  }

//跳转到企业认领页面
  goToClaim() {
    let thiss = this;
    if (this.userType == "enterprise") {
      thiss.showAlert.error({content: '只有个人实名账户才能认领企业', width: '300px', okText: '确认'});
    } else if (this.userType != "enterprise" && this.userType != "person") {
      // thiss.showAlert.error({content: '需要登录后才可以认领企业',width: '300px',okText: '确认'});
      this.openLogin();
    } else {
      // 是否已实名认证
      this.httpService.get("/user/center/xhsRest/isRealAuthent")
        .subscribe(result => {
          if (result.data == "0") {//未认证
            this.showConfirm.confirm({
              title: '',
              content: '您尚未完成个人实名认证，暂时不能使用认领功能，立即前往完成认证？',
              okText: '前往',
              onOk() {
                thiss.router.navigate(['MemberCenterParent/PersonInfoParent/centerRealName'],
                  {queryParams: {companyId: thiss.companyId, type: '2'}});
              },
              onCancel() {
              }
            });
          } else if (result.data == "1") {
            thiss.showConfirm.info({
              content: '您尚未通过个人实名认证审核，请耐心等待',
              okText: '确定'
            });
          } else {//已认证

            thiss.router.navigate(['enterpClaimComponent'], {
              queryParams:
                {companyId: this.companyId, companyName: this.companyInfo.name}
            });
          }
        });
    }

  }

  // 检查该企业是否被该用户认领
  checkClaim() {
    if (this.isClaim) {
      this.showConfirm.info({content: '您已经认领过该企业'});
    }
  }

  //跳转到企业入驻页面
  goToCertific() {
    let thiss = this;
    if (this.userType != "enterprise" && this.userType != "person") {//游客
      if (this.isCertific == '1' || this.isCertific == '2') {
        this.openLogin();
      }
    } else if (this.userType == "enterprise") {//企业
      if (this.isCertific == '1' || this.isCertific == '2') {

      }
    } else {//个人
      if (this.isCertific == '1' || this.isCertific == '2') {//未认证
        // 是否已实名认证
        this.httpService.get("/user/center/xhsRest/isRealAuthent")
          .subscribe(result => {
            if (result.data == "0") {//未认证

              this.showConfirm.confirm({
                title: '',
                content: '您尚未完成个人实名认证，暂时不能进行企业入驻申请，立即前往完成实名认证？',
                okText: '前往',
                onOk() {
                  thiss.router.navigate(['MemberCenterParent/PersonInfoParent/centerRealName'],
                    {queryParams: {companyId: thiss.companyId, type: '3'}});
                },
                onCancel() {
                }
              });
            } else if (result.data == "1") {
              thiss.showConfirm.info({
                content: '您尚未通过个人实名认证审核，请耐心等待',
                okText: '确定'
              });
            } else {//已认证
              // 统一社会信用代码存在
              if (thiss.companyInfo && thiss.companyInfo.creditCode) {
                if (thiss.isUnderEntry == '1') {
                  if ((thiss.order.payStatus == "0" || thiss.order.payStatus == "-1") && thiss.order.orderStatus == "0") {
                    thiss.showConfirm.error(
                      {
                        content: "您已经提交该企业入驻申请,完成支付后才可进入审核环节,是否立即前往支付？",
                        okText: '立即支付',
                        cancelText: '取消',
                        onOk() {
                          thiss.router.navigate(["/pay"],
                            {
                              queryParams: {
                                orderNo: thiss.order.orderNo,
                                orderType: thiss.order.orderType,
                                orderName: "企业入驻审核费"
                              }
                            });
                        },
                        onCancel() {
                        }
                      });
                  } else if ((thiss.order.payStatus == "0" || thiss.order.payStatus == "-1") && thiss.order.orderStatus == "2") {
                    if (this.newEnter == null || this.newEnter == undefined) {
                      thiss.router.navigate(['registerEnterp'], {queryParams: {companyId: thiss.companyId, type: '2'}});
                    } else {
                      thiss.router.navigate(['registerEnterp'], {
                        queryParams: {
                          companyId: thiss.companyId,
                          orderNo: this.orderNo,
                          bankDeposit: this.bankDeposit,
                          bankAccountNo: this.bankAccountNo,
                          cityId: this.cityId,
                          cityName: this.cityName,
                          provinceId: this.provinceId,
                          provinceName: this.provinceName,
                          bankAccountName: this.bankAccountName, type: '2'
                        }
                      });
                    }
                  } else {
                    thiss.showAlert.error({content: '您已经提交该企业入驻申请，可进入个人中心-入驻企业查看当前进度', width: '350px', okText: '确认'});
                  }
                } else {
                  if (this.newEnter == null || this.newEnter == undefined) {
                    thiss.router.navigate(['registerEnterp'], {queryParams: {companyId: thiss.companyId, type: '2'}});
                  } else {
                    thiss.router.navigate(['registerEnterp'], {
                      queryParams: {
                        companyId: thiss.companyId,
                        orderNo: this.orderNo,
                        bankDeposit: this.bankDeposit,
                        bankAccountNo: this.bankAccountNo,
                        cityId: this.cityId,
                        cityName: this.cityName,
                        provinceId: this.provinceId,
                        provinceName: this.provinceName,
                        bankAccountName: this.bankAccountName, type: '2'
                      }
                    });
                  }

                }
              } else {
                thiss.showAlert.error({content: '该企业未进行三证合一,尚无统一社会信用码,请到工商部门换发新版营业执照', width: '350px', okText: '确认'});
              }
            }
          });
        //认证中或已认证
      } else {
        thiss.showAlert.error({content: '该企业已入驻，如有异议可联系客服反馈', width: '300px', okText: '确认'});
      }

    }
  }

  //企业入驻登录弹窗
  rzOpenLogin() {
    this.isVisible3 = false;
    this.openLogin();
  }

  //企业入驻注册带参跳转
  rzToRegisterEnterp() {
    this.toRegisterEnterp();
    this.isVisible3 = false;
  }

  //创建企业名片
  creditCard() {
    let thiss = this;
    if (this.userType != "enterprise" && this.userType != "person") {//游客
      this.openLogin();
    } else if (this.userType == "person") {//个人
      this.isVisible2 = true;
    } else {//企业
      if (this.aType != 1) {
        if (this.logCompanyId != this.companyId) {//非本公司
          this.isVisible = true;
        } else {
          this.router.navigateByUrl("BusinessCardParent/EnterpDevelopment");
          /**
           * 名片协议弹出，目前协议内容不确定，确定后放开次功能
           */
          // this.mbcenterEnterpInfoService.getEnterInfo(this.user.id)
          //   .subscribe(data => {
          //     if (data.data.cardType == '1') {
          //       this.isVisible = false;
          //       this.router.navigateByUrl("BusinessCardParent/EnterpDevelopment");
          //     } else {
          //       this.isVisible = true;
          //     }
          //   });
        }
      } else {
        this.router.navigateByUrl("BusinessCardParent/EnterpDevelopment");
        /**
         * 名片协议弹出，目前协议内容不确定，确定后放开次功能
         */
        // this.mbcenterEnterpInfoService.getEnterInfo(this.user.id)
        //   .subscribe(data => {
        //     if (data.data.cardType == '1') {
        //       this.isVisible = false;
        //       this.router.navigateByUrl("BusinessCardParent/EnterpDevelopment");
        //     } else {
        //       this.isVisible = true;
        //     }
        //   });
      }

    }
  }

  //企业点击创建名片个人登录弹窗
  mpOpenLogin() {
    this.openLogin();
    this.isVisible = false;
  }

  //企业点击创建名片弹窗跳转企业注册
  mpToRegisterEnterp() {
    this.toRegisterEnterp();
    this.isVisible = false;
  }

  //个人点击创建名片个人登录弹窗
  pmpOpenLogin() {
    this.openLogin();
    this.isVisible2 = false;
  }

  //个人点击创建名片弹窗跳转企业注册
  pmpToRegisterEnterp() {
    this.httpService.get("/auth/jwt/logout").subscribe(data => {
      this.globalService.checkLoginState();
      this.globalService.deleteLocalStorage();
      this.globalService.isLoginedUser = false;
      this.router.navigate(['registerEnterp'], {queryParams: {type: '1'}});
    });
    this.isVisible2 = false;
  }

  //企业名片确认阅读协议
  /*checkProtocol() {
    this.isVisible = false;
    this.router.navigateByUrl("BusinessCardParent/EnterpDevelopment");
    this.user['cardType'] = '1';
    this.mbcenterEnterpInfoService.updateEnterpInfo2(this.user).subscribe(data => {
    });
  }*/

  // 隐藏弹框
  handleCancel = () => {
    this.isVisible = false;
    this.isVisible2 = false;
    this.isVisible3 = false;
  }


  ready() {

    $('html,body').animate({scrollTop: $('.jbxx').offset().top - 650}, 800);

  }

  //已入驻企业提示
  notGoin() {
    let thiss = this;
    if (this.userType != "enterprise" && this.userType != "person") {//游客
      this.showConfirm.confirm(
        {
          content: '该企业已经入驻新华信用平台，如有异议请联系客服进行处理，客服电话：010-88052705。', okText: '登录',
          onOk() {
            thiss.openLogin();
          }
        });
      // this.showAlert.error({content: '该企业已被入驻平台，如有异议可登录后联系客服进行反馈',width: '300px',okText: '确认'});
    } else if (this.userType == "person") {//个人登陆
      this.showConfirm.confirm(
        {
          content: '该企业已经入驻新华信用平台，如有异议请联系客服进行反馈，客服电话：010-88052705。', okText: '联系客服',
          onOk() {
            thiss.router.navigateByUrl('MemberCenterParent/contactCustomer');
          }
        });
    }
  }

  /**
   * 计算企业信用分
   */
  calcScore() {
    this.eps.calcScore(this.companyId).subscribe(result => {
      console.log(result);
      if (result.stateCode == '1') {
      }
    });
  }

  //置顶
  ready1() {
    $(document).ready(function ($) {
      if ($("meta[name=toTop]").attr("content") == "true") {
        $("#toTop").remove();
        $("<div id='toTop'><img src='../../../assets/plugins/toTop/toTop.png'></div>").appendTo('body');
        $("#toTop").css({
          width: '50px',
          height: '50px',
          bottom: '35px',
          right: '15px',
          position: 'fixed',
          cursor: 'pointer',
          zIndex: '9999999',
        });
        if ($(this).scrollTop() == 0) {
          $("#toTop").hide();
        }
        $(window).scroll(function (event) {
          /* Act on the event */
          if ($(this).scrollTop() == 0) {
            $("#toTop").hide();
          }
          if ($(this).scrollTop() != 0) {
            $("#toTop").show();
          }
        });
        $("#toTop").click(function (event) {
          /* Act on the event */
          $("html,body").animate({
              scrollTop: "0px"
            },
            666
          );
        });
      }
    });

  }

  /* getCompanyUrl(){
   this.CompanyUrl="https://pay.swiftpass.cn/pay/qrcode?uuid=https%3A%2F%2Fqr.alipay.com%2Fbax05546xzmu5mhaizlt8053";

   }*/
  ngOnDestroy(): void {
    $("#toTop").remove();
    this.companyService.isFromQi = false;
  }

  //获取二维码
  getQRCode() {
    //企业是否入驻
    this.httpService.get("/user/center/xhsRest/certifi/isHasCertific",
      {companyId: this.companyId}).subscribe(result => {
      if (result.data == "3") {//已入驻-生成二维码
        this.httpService.get("/enterprise/detail/xhsRest/QRCode/createQRCode",
          {
            companyId: this.companyId, companyName: this.companyName,
            creditCode: this.companyInfo.creditCode
          }).subscribe(res => {
          if (res.stateCode == "1") {
            this.imageQRCode = this.httpService.getImageUrl(res.data);
          } else {
            this.imageQRCode = "../../../assets/images/qrcode-base.jpg";
          }
          $("#imageQRCode").attr("src", encodeURI(this.imageQRCode));
          $("#imageQRCode").show();
        });
      } else {
        $("#imageQRCode").attr("src", encodeURI(this.imageQRCode));
        $("#imageQRCode").show();
      }
    });
  }


  queryEnter(companyId) {
    this.httpService.post("/user/center/xhsRest/certifi/queryEnter", {
      companyId: companyId
    }).subscribe(data => {
      if (data.data != null) {
        this.newEnter = data.data;
        this.provinceId = data.data.provinceId;
        this.provinceName = data.data.provinceName;
        this.cityId = data.data.cityId;
        this.cityName = data.data.cityName;
        this.bankAccountNo = data.data.bankAccountNo;
        this.bankAccountName = data.data.bankAccountName;
        this.bankDeposit = data.data.bankDeposit;
        this.orderNo = data.data.orderNo;
      }
    });
  }
}



// WEBPACK FOOTER //
// E:/java/gd-project/credit-gd-web/src/app/components/enterp-introduction/enterp-introduction.component.ts